import { Rental } from '@/features/games/shared/types/purchase-history.types';

export const getRentalExpiration = (rentals: Rental[], sku: string) => {
  const matchingRental = rentals.find((rental) => {
    const isActiveState = rental.state !== 'revoked' && rental.state !== 'ended';
    const matchedKey = rental.productKey === sku;
    return isActiveState && matchedKey;
  });

  if (!matchingRental) return undefined;

  if (matchingRental.state === 'purchased' || matchingRental.state === 'ended') {
    return matchingRental.rentalGracePeriodEndMs;
  }

  if (matchingRental.state === 'started') {
    const start = matchingRental.rentalPurchaseTimeMs ?? 0;
    const duration = matchingRental.rentalLengthMs ?? 0;
    return start + duration;
  }

  return undefined;
};
